import { render, staticRenderFns } from "./CadastrarMonitoramentoSocioAmbiental.vue?vue&type=template&id=6a8f80b6&scoped=true&lang=pug"
import script from "./CadastrarMonitoramentoSocioAmbiental.vue?vue&type=script&lang=js"
export * from "./CadastrarMonitoramentoSocioAmbiental.vue?vue&type=script&lang=js"
import style0 from "./CadastrarMonitoramentoSocioAmbiental.vue?vue&type=style&index=0&id=6a8f80b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8f80b6",
  null
  
)

export default component.exports